import { TestTypeEntity } from 'src/store/test-type/test-type.model';

export class TestTypeViewModel implements TestTypeEntity {
  public id: string;
  public code: string;
  public description: string;

  constructor(testType: TestTypeEntity) {
    Object.assign(this, testType);
  }

  public displayName() {
    return `${this.description}`;
  }
}
